<template>
  <div></div>
</template>

<script>
import gzh from '@/assets/gzh.png'
export default {
  props: ['mobile_flag'],
  data () {
    return {
      bLogin1: false,
      gzh: gzh
    }
  },
  methods: {
    fClose () {
      this.bLogin1 = false
      this.$router.push('./Center')
    }
  },
  mounted () {
    let land = this.$route.query.land
    if (land) {
      this.bLogin1 = true
    }
  }
}
</script>

<style lang="scss" spaced>
strong {
  // color: #e77705;
  font-weight: bold;
  font-size: 15px;
}
.el-dialog__headerbtn {
  top: 20px;
  line-height: 10px;
  background-color: transparent;
}
.el-dialog__close {
  background-color: transparent;
}
.u-Reminde {
  color: #fff;
  margin-top: -45px;

  h2 {
    text-align: center;
    font-size: 30px;

    span {
      display: inline-block;
      line-height: 0.9;
      border-bottom: 5px solid #ffcc00;
    }
  }

  dl {
    font-size: 13px;
    margin: 0 auto;
    font-family: NotoSansHans-Regular, NotoSansHans;
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
    dt,
    dd {
      line-height: 2;
      font {
        color: #ffcc00;
      }
    }
  }

  img {
    width: 100px;
    display: block;
    margin: 15px auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/base/LoginSucce.vue